module.exports = __webpack_public_path__ + "img/0040.679e5c5d.png";